(function () {
  const RATE = 1.95583;

  // ---------- Helpers ----------
  function formatEURFromBGN(bgn) {
    return (bgn / RATE).toFixed(2).replace('.', ',') + ' €';
  }

  function formatBGN(bgn) {
    // show with 2 decimals and dot (matches your admin style)
    return Number(bgn).toFixed(2) + ' лв';
  }

  // Convert Shopify "cents" to BGN
  function centsToBgn(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return null;
    return n / 100;
  }

  function getVariantId() {
    // 1) URL ?variant=...
    const url = new URL(window.location.href);
    const v = url.searchParams.get('variant');
    if (v) return String(v);

    // 2) common inputs/selects
    const input =
      document.querySelector('input[name="id"]:checked') ||
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');
    if (input) return String(input.value);

    return null;
  }

  function getVariantsFromMeta() {
    // Avone often has ShopifyAnalytics.meta.product.variants
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        const v = window.ShopifyAnalytics.meta.product.variants;
        if (Array.isArray(v) && v.length) return v;
      }
    } catch (e) {}

    // Try to find JSON script containing product data
    const scripts = document.querySelectorAll('script[type="application/json"]');
    for (const s of scripts) {
      const txt = (s.textContent || '').trim();
      if (!txt || txt.length < 50) continue;

      try {
        const data = JSON.parse(txt);
        // common shapes: {product:{variants:[...]}} or {variants:[...]} or {id, variants:[...]}
        if (data && Array.isArray(data.variants) && data.variants.length) return data.variants;
        if (data && data.product && Array.isArray(data.product.variants) && data.product.variants.length) return data.product.variants;
      } catch (e) {}
    }
    return null;
  }

  function getSelectedVariantPriceBGN() {
    const variantId = getVariantId();
    if (!variantId) return null;

    const variants = getVariantsFromMeta();
    if (!variants) return null;

    const v = variants.find(x => String(x.id) === String(variantId));
    if (!v) return null;

    // Shopify returns price in cents in some objects, or as integer.
    // possible fields: price, price_cents, presentment_prices...
    if (v.price != null) {
      // v.price sometimes already in cents (integer) in product JSON
      const bgn = centsToBgn(v.price);
      if (bgn != null) return bgn;
    }

    // Fallback: try to read visible BGN if meta not usable
    return null;
  }

  function isProductPage() {
    const bodyClass = document.body ? (document.body.className || '') : '';
    return (
      bodyClass.includes('template-product') ||
      document.querySelector('[data-section-type="product-template"]') ||
      document.querySelector('.product-single, .product__info, .product-single__meta') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function pickMainPriceEl() {
    // Keep it simple: pick first visible element that contains 'лв' near the product title area
    const candidates = document.querySelectorAll('.product-single__price, .product__price, .product-price, .price, .money, [data-product-price], [data-price]');
    for (const el of candidates) {
      const t = (el.textContent || '').trim();
      if (!t) continue;
      // On your product page after our fixes, it always contains 'лв'
      if (!t.includes('лв')) continue;
      const r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return el;
    }
    return null;
  }

  function updateProductPrice() {
    if (!isProductPage()) return;

    const el = pickMainPriceEl();
    if (!el) return;

    const bgn = getSelectedVariantPriceBGN();
    if (bgn == null) return; // if we can't read variant price, do nothing (won't break)

    const desired = `${formatBGN(bgn)} / ${formatEURFromBGN(bgn)}`;
    if (el.textContent.trim() !== desired) el.textContent = desired;
  }

  // ---------- Non-product pages: just "(€)" -> "/ €" ----------
  const RE_PAREN_EUR_1 = /\(\s*([0-9][0-9\s.,]*\s*€)\s*\)/g;
  const RE_PAREN_EUR_2 = /\(\s*(€\s*[0-9][0-9\s.,]*)\s*\)/g;
  const RE_ALREADY_SLASH = /\s\/\s*(€|[0-9][0-9\s.,]*\s*€)/;

  function transformParens(text) {
    if (!text) return text;
    if (RE_ALREADY_SLASH.test(text)) return text;
    if (!text.includes('€') || !text.includes('(') || !text.includes(')')) return text;
    return text.replace(RE_PAREN_EUR_1, ' / $1').replace(RE_PAREN_EUR_2, ' / $1');
  }

  function replaceParensEverywhere(root) {
    const r = root || document.body;
    if (!r) return;

    const walker = document.createTreeWalker(
      r,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const v = node.nodeValue || '';
          if (v.includes('€') && v.includes('(') && v.includes(')')) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (const t of nodes) {
      const oldVal = t.nodeValue;
      const newVal = transformParens(oldVal);
      if (newVal !== oldVal) t.nodeValue = newVal;
    }
  }

  // ---------- Run ----------
  function runAll() {
    // Product: correct price for selected variant
    updateProductPrice();

    // Everywhere: parens -> slash
    replaceParensEverywhere(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Variant change hooks
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.name === 'id' || t.closest('form[action*="/cart/add"]')) {
      setTimeout(runAll, 50);
      setTimeout(runAll, 250);
    }
  });

  // Observe dynamic updates
  let raf = null;
  const mo = new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = null;
      runAll();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
